import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { Checkbox, CheckboxGroup, Chip, Divider } from "@heroui/react";
import dayjs from 'dayjs';
import "dayjs/locale/fr";
import relativeTime from "dayjs/plugin/relativeTime";
import { useTranslation } from "react-i18next";
import { PiUserCircleGearFill } from "react-icons/pi";

dayjs.extend(relativeTime);

export default function UserFormProfile({ methods, classNames, dataUser }) {
  const { t, i18n } = useTranslation();
  const [relativeUpdateTime, setRelativeUpdateTime] = useState("");
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const currentLocale = i18n.language; 
    dayjs.locale(currentLocale);

    setRelativeUpdateTime(dayjs(dataUser?.update_datetime).fromNow(true));
    setFormattedDate(dayjs(dataUser?.update_datetime).format('DD/MM/YYYY'));
  }, [i18n.language, dataUser.update_datetime]); 

  const color = dataUser?.availability === "active" ? "active" : "inactive";

  return (
    <div>
      <div className="border-b-1 border-dashed border-vistagrey/30 p-3 font-bold">
        {t("profile")}
      </div>
      <div className="p-5">
        <div className="flex items-center text-vistadark">
          <PiUserCircleGearFill className={`h-10 w-10 mr-2 ${color === "active" ? "fill-vistactagreen" : "fill-vistactared"}`} />
          {dataUser.user_name} {dataUser.user_given_name}
        </div>
        <div className="py-2 text-[10px] uppercase text-vistagrey/60">
          {t("status")}:{" "}
          <span className="ml-1 text-vistagrey text-sm">
            <Chip
              classNames={{
                base: `${color === "active" ? "bg-vistactagreen" : "bg-vistactared"} border-small`,
                content: "text-white",
              }}
              size="sm"
            >
              {dataUser.availability}
            </Chip>
          </span>
        </div>
        <div className="py-2 text-[10px] uppercase text-vistagrey/60">
          {t("user_id")}: <br />
          <span className="text-vistadark text-xs">{dataUser.user_id}</span>
        </div>
        <div className="py-2 text-[10px] uppercase text-vistagrey/60">
          {t("last_update")}: <br />
          <span className="text-vistadark text-xs">
            {t("ago", { time: relativeUpdateTime })} ({formattedDate})
          </span>
        </div>

        <Divider className="my-5" />

        <Controller
          name="user_group"
          control={methods.control}
          render={({ field }) => (
            <CheckboxGroup
              {...field}
              label={t("user_profile")}
              classNames={classNames}
              color="default"
              size="sm"
            >
              <Checkbox value="Admins">{t("profil_administrator")}</Checkbox>
              <Checkbox value="DataEntrySupervisors">
                {t("profil_data_entry_supervisors")}
              </Checkbox>
              <Checkbox value="DataEntryOperators">
                {t("profil_data_entry_operator")}
              </Checkbox>
              <Checkbox value="DataReadOnlyOperators">
                {t("profil_data_read_only_operators")}
              </Checkbox>
            </CheckboxGroup>
          )}
        />
      </div>
    </div>
  );
}